import {getImageTilesURL, getMosaicTilesURL} from '../api.js';

export function getImageryURL(layer, token) {
  const [type, id] = getLayerTypeAndId(layer);
  if (type === 'Mosaic') {
    return getMosaicTilesURL(id, token);
  } else {
    return getImageTilesURL(type, id, token);
  }
}

/**
 * @param {string} layer A layer name (e.g. "Mosaic:mosaic_2020-01-01" or "PSScene:20191231_180344_0f3a")
 * @return {boolean} The layer is a mosaic.
 */
export function isMosaicLayer(layer) {
  return layer.startsWith('Mosaic:');
}

/**
 * @param {string} layer A layer name (e.g. "Mosaic:mosaic_2020-01-01" or "PSScene:20191231_180344_0f3a")
 * @return {Array<string>} An array with the layer type and id.
 */
export function getLayerTypeAndId(layer) {
  return layer.split(':');
}
